const CONSENT_KEY = 'synkro_cookie_consent';

export const getConsent = () => {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const hasAnalyticsConsent = () => {
  const consent = getConsent();
  return consent?.analytics === true;
};
